// extracted by mini-css-extract-plugin
export default {"container":"_12YtNua4WRIwLE3ZReJ6dk"};